import { UseTableSelect } from "@/common/hooks/useTableSelect";
import Checkbox from "../Checkbox";

const SelectAllCheckbox = ({ tableSelect }: { tableSelect: UseTableSelect; }) => {
  return (
    <th
      className="text-left px-5 border-x z-30 border-x-[#64676980] py-6 text-sm font-bold"
      key={'table_select_all'}
    >
      <Checkbox
        label=""
        name=""
        labelContainerClassName="hidden"
        checked={tableSelect?.isAllSelected}
        onChange={(event) => tableSelect?.selectAll(event.currentTarget.checked)}
      />
    </th>
  );
};

export default SelectAllCheckbox;
